import React from "react";

export default function SettingIcon(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.52863L9.89868 5.70279C9.67502 5.9342 9.36698 6.06488 9.04515 6.06488H6.06488V9.04515C6.06488 9.36699 5.9342 9.67502 5.70279 9.89868L3.52863 12L5.70279 14.1013C5.9342 14.325 6.06488 14.633 6.06488 14.9548V17.9351H9.04515C9.36698 17.9351 9.67502 18.0658 9.89868 18.2972L12 20.4714L14.1013 18.2972C14.325 18.0658 14.633 17.9351 14.9548 17.9351H17.9351V14.9548C17.9351 14.633 18.0658 14.325 18.2972 14.1013L20.4714 12L18.2972 9.89869C18.0658 9.67503 17.9351 9.36699 17.9351 9.04516V6.06488H14.9548C14.633 6.06488 14.325 5.9342 14.1013 5.70279L12 3.52863ZM11.1465 2.36209C11.6131 1.8793 12.3869 1.8793 12.8535 2.36209L15.0556 4.64045H18.1725C18.8281 4.64045 19.3596 5.1719 19.3596 5.82747V8.94445L21.6379 11.1465C22.1207 11.6131 22.1207 12.3869 21.6379 12.8535L19.3596 15.0556V18.1725C19.3596 18.8281 18.8281 19.3596 18.1725 19.3596H15.0556L12.8535 21.6379C12.3869 22.1207 11.6131 22.1207 11.1465 21.6379L8.94444 19.3596H5.82747C5.1719 19.3596 4.64045 18.8281 4.64045 18.1725V15.0556L2.36209 12.8535C1.8793 12.3869 1.8793 11.6131 2.36209 11.1465L4.64045 8.94444V5.82747C4.64045 5.1719 5.1719 4.64045 5.82747 4.64045H8.94444L11.1465 2.36209Z"
        fill="#A6B0CF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.48931 12C7.48931 9.50881 9.50881 7.48931 12 7.48931C14.4912 7.48931 16.5107 9.50881 16.5107 12C16.5107 14.4912 14.4912 16.5107 12 16.5107C9.50881 16.5107 7.48931 14.4912 7.48931 12ZM12 8.91374C10.2955 8.91374 8.91374 10.2955 8.91374 12C8.91374 13.7045 10.2955 15.0863 12 15.0863C13.7045 15.0863 15.0863 13.7045 15.0863 12C15.0863 10.2955 13.7045 8.91374 12 8.91374Z"
        fill="#A6B0CF"
      />
    </svg>
  );
}
